import { useRef, useState } from "react"
import { FormInput } from "../../components/forms/form-input"
import { SiteHeader } from "../../components/header/header"
import { faEye, faEyeSlash } from "@fortawesome/free-solid-svg-icons";
import { useAuthentication } from "../../services/authentication/authentication.context";
import { isNull } from "../../_helpers/isNull";
import { AppAlert } from "../../components/utils/alert";
import { LoadingIndicator } from "../../components/utils/loader";

export const RegistrationPage = () => {

    const { registerAccount, isLoading } = useAuthentication();

    const [userData, setUserData] = useState({
        names: '',
        email: '',
        password: '',
        repeatPassword: ''
    });

    const subBttn = useRef();

    const [showPassword, setShowPassword] = useState(false);
    const [showRepeat, setShowRepeat] = useState(false);
    const [onAlert, setOnAlert] = useState();

    const { names, email, password, repeatPassword } = userData;

    const handleInput = (e) => {
        setUserData((data) => ({ ...data, [e.target.name]: e.target.value }));
    }

    const handleRegister = async (data) => {
        const dataProps = Object.keys(data);
        if (dataProps.some((prop) => isNull(data[prop]))) {
            setOnAlert({
                caption: "Invalid data!",
                message: "Please provide all the required data",
                accept: "Ok",
                onAccept: () => setOnAlert(false)
            });
            return;
        }
        if (data.password !== data.repeatPassword) {
            setOnAlert({
                caption: "Password error!",
                message: "Passwords do not match!",
                accept: "Ok",
                onAccept: () => setOnAlert(false)
            });
            return;
        }
        try {
            const resp = await registerAccount(data);
            if (resp?.error) {
                setOnAlert({
                    caption: "Error!",
                    message: resp?.error,
                    accept: "Ok",
                    onAccept: () => {
                        setOnAlert(false);
                    }
                });
                return;
            }
            setOnAlert({
                caption: "Success!",
                message: resp?.message,
                accept: "Ok",
                onAccept: () => {
                     setOnAlert(false);
                    window.location.reload();
                }
            });
        } catch (error) {
            console.log({ error });
        }
    }

    return (
        <div className="app-body">
            <SiteHeader pageTitle={'Registration'} />
            {isLoading && <LoadingIndicator />}
            {onAlert && (
                <AppAlert
                    caption={onAlert.caption}
                    message={onAlert.message}
                    accept={onAlert.accept}
                    onAcept={onAlert.onAccept}
                    onClose={() => setOnAlert()}
                />
            )}
            <div className="slogan-1 login-cap">WELCOME</div>
            <div className="slogan-2 login-cap">Create your account</div>
            <div className="form-container">
                <form 
                    className="login-form"
                    onSubmit={(e) => {
                        e.preventDefault();
                    }}
                >
                    <FormInput
                        type={"text"}
                        name={"names"}
                        value={names}
                        onChange={(e) => handleInput(e)}
                        label={"Names e.g. John Doe"}
                        required={true}
                    />
                    <FormInput
                        type={'email'}
                        name={'email'}
                        value={email}
                        onChange={(e) => handleInput(e)}
                        label={"Email e.g. johndoe@example.com"}
                        required={true}
                    />
                    <FormInput
                        type={showPassword ? 'text' : 'password'}
                        name={'password'}
                        value={password}
                        label={"Password"}
                        formIcon={showPassword ? faEyeSlash : faEye}
                        toggleIcon={(e) => {
                            e.preventDefault();
                            setShowPassword((show) => !show)
                        }}
                        onChange={(e) => handleInput(e)}
                        required={true}
                    />
                    <FormInput
                        type={showRepeat ? 'text' : 'password'}
                        name={'repeatPassword'}
                        value={repeatPassword}
                        label={"Repeat password"}
                        formIcon={showRepeat ? faEyeSlash : faEye}
                        toggleIcon={(e) => {
                            e.preventDefault();
                            setShowRepeat((show) => !show)
                        }}
                        onChange={(e) => handleInput(e)}
                        required={true}
                    />
                    <button
                        className="form-button"
                        onClick={async () => await handleRegister(userData)}
                    >
                        Register
                    </button>
                    <div className="action text">
                        <span>Already have an account?</span>
                        <a href="/login" className="action-link">Sign in</a>
                    </div>
                </form>
            </div>
        </div>
    )
}